const ConfigProvider = _BuildConfig(window.config);

function _BuildConfig(Config) {
    const Sitio = config.Sitio;
    const Comscore = config.Comscore;
    const Statics = config.Statics;

    if (!Sitio.Url) {
        Sitio.Url = location.origin;

        if (!Sitio.Url.endsWith('/'))
            Sitio.Url += '/';
    }

    return {
        Config: Config,
        Sitio: Sitio,
        Comscore: Comscore,
        BucketUrl: Statics.BucketUrl,
        ApiContenidosRankingSitioUrl: `${Statics.ApiContenidosUrl}${Statics.ApiContenidosRankingSitioEndpoint}${Sitio.Id}`,
        ApiContenidosUltimasNotasUrl: `${Statics.ApiContenidosUrl}${Statics.ApiContenidosNotas}`,
        ApiNewsletterSuscripcionUrl: `${Statics.ApiLoginUrl}${Statics.ApiNewsletterSuscripcionEndpoint}`,
        BuscadorUrl: Statics.BuscadorUrl,
        LoginUrl: Statics.LoginUrl + window.btoa(location.href),
        LogoutUrl: `${Statics.SitioSeguroRegistracion}/logout/logout.html?pagina=${window.location.origin}${Statics.LogoutUrl}`,
        NetworkLF: Statics.NetworkLF,
        SiteIdLF: Statics.SiteIdLF     
    };
}

export default ConfigProvider;


// WEBPACK FOOTER //
// ./Statics/scripts/Core/Configuration/ConfigProvider.js